<template lang="html">
  <div class="add-phone text-center">

    <!-- ================= -->
    <!-- Phone form -->
    <!-- ================= -->
    <form  v-if="!waitingCode && !showTransferWarning" @submit.prevent="submit()" class="form-group">
      <div class="d-flex justify-content-around justify-content-sm-center">

        <!-- SMS  -->
        <div class="phone-type mr-sm-3">
          <label class="phone-type-label" for="mobile">
            <font-awesome-icon class="phone-type-icon mr-1" :icon="[ 'fas', 'mobile' ]" />
            SMS
          </label>
          <input id="mobile"
                 type="radio"
                 class="phone-type-radio"
                 @input="changePhoneType"
                 v-model="phoneType"
                 value="mobile">
        </div>

        <!-- Call -->
        <div class="phone-type ml-sm-3">
          <label class="phone-type-label" for="landLine">
            <font-awesome-icon class="phone-type-icon mr-1" :icon="[ 'fas', 'phone' ]" />
            Llamada
          </label>
          <input id="landLine"
                 type="radio"
                 class="phone-type-radio"
                 @input="changePhoneType"
                 v-model="phoneType"
                 value="land_line">
        </div>

      </div>


      <div class="mx-auto" style="max-width: 380px">
      <label v-if="action === 'FIRST'" for="newPhone">Para poder publicar en nuestro sitio, necesitás agregar un número de teléfono</label>
      <label v-if="isMobile" for="newPhone">Ingresá tu número de celular, sin 0 y sin 15. Te enviaremos un código de verificación.</label>
      <label v-else for="newPhone">Ingresá tu número de teléfono fijo, sin 0. Recibirás una llamada con el código.</label>
      <!-- <label>Un  número de teléfono sólo puede estar vinculado a una cuenta.</label> -->

      <!-- Input field -->
      <input
        maxlength="13"
        @input="checkInput"
        @focus="cleanErrors"
        @keypress.enter.prevent="submit()"
        id="newPhone"
        v-model="formattedPhone"
        class="form-control mt-3 mb-0"
        type="text"
        placeholder="Ejemplo: 3492 461234">
      </div>

      <!-- Validation error -->
      <div v-if="showError" class="error">
        <ul style="list-style-type:none; padding-inline-start: 0;">
          <li v-for="(error,index) in errorMessages" :key="`error-${index}`">
            <ul style="list-style-type:none; padding-inline-start: 0;">
              <li v-for="(message,index) in error" :key="`message-${index}`">
                {{message}}
              </li>
            </ul>
          </li>
        </ul>
      </div>

      <!-- Buttons -->
      <div class="mt-3 w-100 text-center">
        <SquaredButton
          @click="$emit('close')"
          type="button"
          styleType="default"
          noUpperCase
          label="Cancelar" />
        <SquaredButton
          :isWaiting="isFetching"
          :disabled="number.length !== 10 || isFetching"
          type="submit"
          styleType="primary"
          noUpperCase
          label="Enviar" />
      </div>
    </form>

    <!-- ================= -->
    <!-- Transfer warning -->
    <!-- ================= -->

    <form v-else-if="!waitingCode && showTransferWarning" @submit.prevent="askPhoneTransfer" class="form-group text-center mb-0">

      <label class="mb-5 mt-2 warning-message">
        {{ warningMessage }}
      </label>

      <!-- Buttons -->
      <div class="w-100 text-center">
        <SquaredButton
          @click="$emit('close')"
          type="button"
          styleType="default"
          noUpperCase
          label="Cancelar" />
        <SquaredButton
          :isWaiting="isFetching"
          :disabled="isFetching"
          type="submit"
          styleType="primary"
          noUpperCase
          label="Continuar de todas maneras" />
      </div>

    </form>

    <!-- ================= -->
    <!-- Code form  -->
    <!-- ================= -->
    <form v-else-if="waitingCode" @submit.prevent="verify" class="form-group text-center mb-0">

      <!-- icon -->
      <font-awesome-icon v-if="showTransferWarning" :icon="[ 'fas', 'exclamation-triangle' ]" size="5x" :style="{ color: 'var(--danger)' }" />

      <!-- warning message -->
      <label v-if="showTransferWarning" class="my-4 warning-message">
        {{ warningMessage }}
      </label>

      <label for="code">
        Colocá el código que te enviamos por {{ isMobile ? 'SMS' : 'mensaje de voz' }} a <strong>{{number}} </strong>
        <a href="#" @click.prevent="editPhone">(corregir)</a>
      </label>

      <!-- code field -->
      <input
        v-model="code"
        id="code"
        @input="cleanErrors"
        @focus="cleanErrors"
        @keypress.enter.prevent="verify"
        class="form-control my-3"
        type="number">

      <!-- error message  -->
      <div v-if="showError" class="error">
        <ul style="list-style-type:none; padding-inline-start: 0;">
          <li v-for="(error, index) in errorMessages" :key="`error-${index}`">
            <ul style="list-style-type:none; padding-inline-start: 0;">
              <li v-for="(message, index) in error" :key="`message-${index}`">
                {{message}}
              </li>
            </ul>
          </li>
        </ul>
      </div>

      <p class="mb-3">El mensaje puede tardar hasta un minuto en llegarte.</p>

      <!-- Buttons -->
      <div class="my-2 mx-auto text-center" style="max-width: 60%">
        <SquaredButton
          :isWaiting="isFetching"
          :disabled="!code || isFetching"
          type="submit"
          styleType="primaryLargeBlock"
          noUpperCase
          label="Verificar" />
      </div>

      <!-- resend link -->
      <div class="text-center">
        <button :disabled="count > 0 || isFetching"
                type="button"
                @click="resendCode"
                class="btn btn-link pr-0 align-baseline">
          Reenviar código
        </button>
        <span v-if="count > 0">{{ count ? ` (${count}s)` : '' }}</span>
      </div>

    </form>

  </div>
</template>

<script>
import store from "@/store";
import userUtilsMixin from "@/mixins/userUtils";
import { instance as snack } from "@/components/layout/SnackMessage";
import { filterNumbersOnly, formatPhone } from "@/helpers";

export default {
  name: "AddPhone",
  mixins: [userUtilsMixin],

  props: {
    then: Function,
    props: Object,
  },

  data: () => ({
    number: "",
    code: "",
    isFetching: false,
    waitingCode: false,
    showError: false,
    errorMessages: {},
    phoneType: "mobile",
    showTransferWarning: false,
    warningMessage: "",
  }),

  computed: {
    formattedPhone: {
      get () {
        return formatPhone(this.number);
      },

      set (val) {
        const trimmedVal = filterNumbersOnly(val);

        if (trimmedVal.length > 10) return;

        this.number = trimmedVal;
      },
    },

    action () {
      return this.props && this.props.action;
    },

    count () {
      return this.userUtilsCount;
    },

    isCommerce: () => store.getters["user/isCommerce"],

    isMobile () {
      return this.phoneType === "mobile";
    },
  },

  methods: {
    filterNumbersOnly,
    formatPhone,

    checkInput (e) {
      if (this.showError) this.showError = false;

      if (!/\d/.test(e.data) || this.number.length === 10) {
        e.target.value = e.target.value.slice(0, -1);
      }
    },

    changePhoneType () {
      if (this.showError) this.showError = false;
      this.formattedPhone = "";
    },


    // This function is called for regular phone verification and for phone transfer
    submit (transfer = false) {
      if (this.showError) this.showError = false;
      this.isFetching = true;

      return store
        .dispatch("user/sendPhone", {
          phone: this.number,
          type: this.phoneType,
          transfer: transfer,
        })
        .then((res) => {
          if (res.status === "phone_already_verified_by_another_user") {
            this.showTransferWarning = true;
            this.warningMessage = res.message;
          } else {
            this.waitingCode = true;
            // Activate user countdown
            this.userUtilsCount = 60;
            this.userUtilsCountdown();
          }
        })
        .catch((er) => {
          const messages = er.response && er.response.data && er.response.data.error &&
            er.response.data.error.message && er.response.data.error.message.errors;
          if (messages) {
            this.errorMessages = messages
          }
          this.showError = true
        })
        .finally(() => {
          this.isFetching = false
        });
    },

    async askPhoneTransfer () {
      await this.submit(true);
    },

    resendCode () {
      return this.submit();
    },

    editPhone () {
      this.waitingCode = false;
      this.code = "";
    },

    verify () {
      const phone = this.number;
      const code = this.code;
      const availability = this.isMobile ? "ALL" : "ONLY_CALL";
      const transfer = this.showTransferWarning;
      this.isFetching = true;

      return store
        .dispatch("user/verifyPhone", { code, phone, availability, transfer })
        .then((res) => {
          this.$emit("close");
          this.showTransferWarning = false;

          snack({
            title: "Nuevo teléfono",
            text: `Has añadido ${phone}`,
          });
          return store.dispatch("user/fetchUserInfo").then(() => {
            if (!!this.then) this.then();
          });
        })
        .catch((er) => {
          const messages = er.response && er.response.data && er.response.data.error &&
            er.response.data.error.message && er.response.data.error.message.errors;
          if (messages) {
            this.errorMessages = messages
          }
          this.showError = true
        })
        .finally(() => {
          this.isFetching = false
        });
    },

    cleanErrors () {
      this.showError = false;
      this.errorMessage = {};
    },
  },
};
</script>

<style lang="scss">
@import "../../scss/colors";

.add-phone {
  & .error {
    display: block;
    color: var(--danger);
    text-align: center;
    padding-top: 0.5rem;
    padding-bottom: 0;
    margin-right: auto;
    margin-left: auto;
    padding-left: 5px;
    max-width: 360px;
    font-size: 0.9rem;
  }
}

.phone-type {
  &-label {
    padding: 8px 4px;
    cursor: pointer;
    margin: 0;
  }

  &-radio {
    cursor: pointer;
    &:checked {
      opacity: 0.75;
    }
  }

  &-icon {
    color: $primary;
  }
}

.warning-message {
  // color: var(--danger);
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/user/AddPhone.vue